import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { ContactAddressFormPanel } from '@/components/organisms/contacts/ContactAddressFormPanel';
import { useContact } from '@/hooks/contacts/useContact';
import { useContactAddresses } from '@/hooks/contacts/useContactAddresses';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/$contactId/addresses/new')({
  component: NewContactAddressPage,
});

function NewContactAddressPage() {
  const { contactId } = Route.useParams();
  const navigate = useNavigate();
  const contactQuery = useContact(contactId);
  const addressesQuery = useContactAddresses(contactId);

  function navigateToContact() {
    void navigate({
      to: '/dashboard/contacts/$contactId',
      params: { contactId },
    });
  }

  if (contactQuery.isError && contactQuery.error?.status === 404) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <AlertCircle className="h-10 w-10 text-muted-foreground" />
        <div>
          <p className="font-semibold">Contact not found</p>
          <p className="text-sm text-muted-foreground">The contact may have been deleted.</p>
        </div>
        <Button onClick={() => navigate({ to: '/dashboard/contacts' })}>Back to Contacts</Button>
      </div>
    );
  }

  return (
    <ContactAddressFormPanel
      mode="create"
      contactId={contactId}
      addressesCount={addressesQuery.data?.length ?? 0}
      isLoading={contactQuery.isLoading || addressesQuery.isLoading}
      onCancel={navigateToContact}
      onSaved={navigateToContact}
    />
  );
}
